import { useEffect, useRef } from "react";
import { collectBranchFeatureIds, collectUnhealthyExpansionIds, hasProblem } from "./healthTree";
const useTreeExpansion = (tree, root, viewMode) => {
  const appliedRef = useRef({
    viewMode: null,
    ids: /* @__PURE__ */ new Set()
  });
  useEffect(() => {
    if (appliedRef.current.viewMode !== viewMode) {
      appliedRef.current = { viewMode, ids: /* @__PURE__ */ new Set() };
    }
    const targetIds = hasProblem(root) ? collectUnhealthyExpansionIds(root) : collectBranchFeatureIds(root);
    const target = new Set(targetIds);
    const applied = new Set([...appliedRef.current.ids].filter((id) => target.has(id)));
    appliedRef.current.ids = applied;
    targetIds.forEach((id) => {
      if (applied.has(id)) return;
      applied.add(id);
      tree.expand(id);
    });
  });
};
export default useTreeExpansion;
